import { render, staticRenderFns } from "./CadastrarOperacao.vue?vue&type=template&id=23bc9f28&scoped=true&lang=pug"
import script from "./CadastrarOperacao.vue?vue&type=script&lang=js"
export * from "./CadastrarOperacao.vue?vue&type=script&lang=js"
import style0 from "./CadastrarOperacao.vue?vue&type=style&index=0&id=23bc9f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc9f28",
  null
  
)

export default component.exports